// File is included from theme.liquid only when settings.graphene_enabled == true
// https://lavishalicedev-1.store.advancedcommerce.services/graphenehc.js

console.log('graphene.js');

document.addEventListener("DOMContentLoaded", function () {
	// ----- Helpers -----
	// Global makes them available to onclick in the html from graphene
	window.openGrapheneFilterDrawer = function() {
		const grapheneFilterDrawer = document.querySelector('.graphene-facets-drawer');
		const grapheneFilterOverlay = document.querySelector('.graphene-facets-overlay');
		if (!grapheneFilterDrawer) return;
		grapheneFilterDrawer.classList.add('open');
		grapheneFilterOverlay.classList.add('open');

		// lock scroll
		//document.body.style.overflow = 'hidden';

		window.addEventListener('keydown', function(e) {
			if (e.key == 'Escape') closeGrapheneFilterDrawer();
		});
	}

	window.closeGrapheneFilterDrawer = function() {
		const grapheneFilterDrawer = document.querySelector('.graphene-facets-drawer');
		const grapheneFilterOverlay = document.querySelector('.graphene-facets-overlay');
		if (!grapheneFilterDrawer) return;
		grapheneFilterDrawer.classList.remove('open');
		grapheneFilterOverlay.classList.remove('open');

		// unlock scroll
		//document.body.style.overflow = '';
	}

	window.toggleGrapheneSort = function() {
		const grapheneSort = document.querySelector('.graphene-sort');
		const grapheneSortDropdown = document.querySelector('.graphene-sort-dropdown');
		if (!grapheneSortDropdown || !grapheneSort) {
			console.log('sort els not found');
			return;
		}

		grapheneSortDropdown.classList.toggle('open');

		// if the user clicks anywhere outside of the dropdown - close it
		const closeGrapheneSort = function(e) {
			if (!grapheneSort.contains(e.target)) {
				grapheneSortDropdown.classList.remove('open');
				window.removeEventListener('click', closeGrapheneSort);
			}
		}

		window.addEventListener('click', closeGrapheneSort);
	}
	
	// if layout pref has been selected, set to local
	window.getGrapheneLayout = function() {
		const grapheneLayout = localStorage.getItem('graphene-layout');
		if (!grapheneLayout) {
			console.log('graphene layout not found - using defaults');
			return {};
		}
	
		try {
			return JSON.parse(grapheneLayout);
		} catch (e) {
			console.warn('Invalid graphene layout JSON in localStorage.');
			return {};
		}
	};
	
	// set layout prefs in local storage as json object eg: {"mobile": 2, "desktop": 3}
	// used to remember selected layout on subsequent pages
	window.setGrapheneLayout = function(device, cols, clickedBtn, fullReload = true) {
		try {
			if ((device !== 'mobile' && device !== 'desktop') || !cols) {
				console.warn('setGrpaheneLayout args missing or incorrect');
				return;
			}
	
			const currentLayout = window.getGrapheneLayout();
			currentLayout[device] = cols;
		
			localStorage.setItem('graphene-layout', JSON.stringify(currentLayout));
			console.log(`Set ${device} layout to:`, cols);
	
			if (fullReload == true) {
				// reload the graphene template (retains layout on sort and filter)
				loadGraphenePLP();
			} else {
				// just update css, new pages retain layout but graphene server still has old layout args
				const grapheneProductList = document.querySelector('.graphene-product-list');
				const grapheneMobileLayoutBtns = document.querySelectorAll('.mobile-layout-btn');
				const grapheneDesktopLayoutBtns = document.querySelectorAll('.desktop-layout-btn');
				if (grapheneProductList) {
					if (device == 'mobile') {
						grapheneProductList.classList.remove('mob-cols-1', 'mob-cols-2');
						grapheneProductList.classList.add(`mob-cols-${cols}`);
	
						grapheneMobileLayoutBtns.forEach((btn) => {
							btn.classList.remove('is-active');
						})
					} else {
						grapheneProductList.classList.remove('dt-cols-3', 'dt-cols-4', 'dt-cols-6')
						grapheneProductList.classList.add(`dt-cols-${cols}`);
	
						grapheneDesktopLayoutBtns.forEach((btn) => {
							btn.classList.remove('is-active');
						})
					}
					clickedBtn.classList.add('is-active');
				}
			}
		} catch (err) {
			// silently fail if localStorage cannot be set, will just use defaults on each page refresh
		}
	};
	
	// ----- Graphene Logic -----
	// toggles dev / live graphene environments from theme settings
	$g.init({
		theme: window.grapheneThemeID
	});

	// init autocomplete
	async function loadGrapheneAC() {
		$g.autocomplete({
			format: "html",
			input_selector: "#graphenehc-ac-input",
			dropdown_selector: "#graphenehc-ac-results",
			page_context: {
				language_id: Shopify.locale,
				currency_id: Shopify.currency.active
			}
		})
	}

	// init plp
	async function loadGraphenePLP() {
		let layout = getGrapheneLayout();
		let mobileCols = layout.mobile || 2;
		let desktopCols = layout.desktop || 3;

		const templateID = window.location.pathname.includes('pages/search') ? 'search' : 'category';
		const urlParams = new URLSearchParams(window.location.search);
		const searchText = urlParams.get('q');
		const sort = urlParams.get('sort');

		const pageContext = {
			language_id: Shopify.locale,
			currency_id: Shopify.currency.active
		};

		const args = {
			enable_quickbuy: true,
			mobile_cols: mobileCols,
			desktop_cols: desktopCols
		}
		
		if (templateID == 'search' && searchText) {
			pageContext.search_text = searchText;
		}

		if (sort) {
			args.sort = sort;
		}

		$g.load({
			template: {
				id: templateID, 
				target: "#graphene-results" 
			},
			page_context: pageContext,
			args: args,
			init: function() {
				console.time('graphene-load');
			},
			success: function(response) {
				console.log('Graphene plp load success');
				document.dispatchEvent(new Event('graphene-loaded'));// if we need to reinit anything
				console.timeEnd('graphene-load');
			}
		});
	}

	// init pdp recommendations
	async function loadGraphenePDPRecs(target) {
		if (!target) return;
		const elementID = target.dataset.grapheneElement;
		if (!elementID) {
			console.log('missing data-graphene-element on target container');
			return;
		}
		console.time('graphene-pdp-recs');
		
		$g.fetch({
			format: 'html',
			elements: [elementID],
			page_context: {
				language_id: Shopify.locale,
				currency_id: Shopify.currency.active
			},
			args: {
				quickbuy: true,
				wishlist: true
			},
			success: function(response) {
				const productCardsHTML = response.elements[elementID].html;
				const tempWrapper = document.createElement('div');
				tempWrapper.innerHTML = productCardsHTML;
				target.innerHTML = ''; // remove placeholders
				// expects <product-card> elements in the returned template
				const productCards = tempWrapper.querySelectorAll('product-card');
				productCards.forEach(card => {
					target.appendChild(card);
				});
				console.timeEnd('graphene-pdp-recs');
			}
		})
	}

	// only init when the recs are near viewport
	const graphenePDPRecs = document.querySelectorAll('.graphene-recommendation-results');
	if ('IntersectionObserver' in window && graphenePDPRecs.length) {
		const observer = new IntersectionObserver((entries, observer) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					const target = entry.target
					loadGraphenePDPRecs(target); // fetch the content
					observer.unobserve(target); // stop observing
				}
			});
		}, {
			rootMargin: '0px 0px 200px 100px', // expand the 'viewport' (L R D U)
			threshold: 0 // 0 - 1
		});
		graphenePDPRecs.forEach(el => observer.observe(el));
	}

	const grapheneSearchInput = document.querySelector('#graphenehc-ac-input');
	if (grapheneSearchInput) {
		loadGrapheneAC();
	}

	const graphenePLPContainer = document.querySelector('#graphene-results');//same on plp and search
	if (graphenePLPContainer) {
		loadGraphenePLP();
	}

	// ----- Graphene Tracking -----
	// listen for postMessage from the Web Pixel (saves reinitting graphene within the sandboxxed pixel environment)
	window.addEventListener('message', function(event) {
		if (event.data?.source === 'web-pixels' && event.data.event === 'graphene_track') {
			const payload = event.data.payload;
			if (typeof $g !== 'undefined' && $g.track) {
				$g.track(payload);
			}
		}
	});
});